import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
type CountdownTimerProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
export function CountdownTimer({
  tone = 'light',
  className = ''
}: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const isDark = tone === 'dark';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-19" data-mp="34pyzo9w8td29">
      <p className={`flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em] ${isDark ? 'text-white/80' : 'text-rose'}`} data-id="element-20" data-mp="2zsqh4876n70h">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-21" data-mp="1h0b28pdugzz0" />
        This special offer ends in:
      </p>

      <div className="mt-3 flex items-stretch gap-2" role="timer" aria-live="off" data-id="element-22" data-mp="123am7j50mtgd">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-23" data-mp="1723xr60qsadw" data-mpi={index}>
            {index > 0 ? <span className={`self-center pb-4 font-display text-2xl font-bold ${isDark ? 'text-white/50' : 'text-navy/35'}`} aria-hidden="true" data-id="element-24" data-mp="1uqwp0p6f5u26">
                :
              </span> : null}
            <div className="flex flex-col items-center" data-id="element-25" data-mp="1pzochk9slsks">
              <span className={`flex min-w-[64px] items-center justify-center rounded-xl px-2 py-2.5 font-display text-3xl font-bold tabular-nums sm:min-w-[76px] sm:text-4xl ${isDark ? 'bg-white text-navy' : 'bg-navy text-white'}`} data-id="element-26" data-mp="1pydbttbn90xw">
                {String(block.value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-[10px] font-bold uppercase tracking-[0.12em] ${isDark ? 'text-white/70' : 'text-navy/55'}`} data-id="element-27" data-mp="2ne62n9vn5evq">
                {block.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>

      <p className={`mt-3 text-center text-[12px] font-semibold ${isDark ? 'text-white/70' : 'text-navy/60'}`} data-id="element-28" data-mp="29fybxjp779t0">
        Limited launch pricing available now.
      </p>
    </div>;
}